import { useState ,useEffect } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom"
import { visualizerActions } from "../../store";
import RoomScene from "../RoomScene/RoomScene"

import styles from './RoomSceneList.module.css'

// Generate a list of roomscenes
export default function RoomSceneList({seriesId, thumbnailSize}) {

    const dispatch = useDispatch();
    const[sceneData, setSceneData] = useState([]);
    const navigate = useNavigate();

    // Pull the roomscene series for the passed series id
    useEffect(()=>{
        const URL = `https://lizard.chameleonpower.com/CDN/RoomScenes/${seriesId}.json`;
        fetch(URL)
        .then((response) => response.json())
        .then((data) => setSceneData(data));
    },[seriesId])

    // Handles roomscene select event
    const handleRoomsceneSelect = function(specifier) {
        dispatch(visualizerActions.clearProductDropdownFilters([]));
        navigate(`/visualizer/spec/${encodeURIComponent(specifier)}/sel/-1`);
    }

    // Generates an array of RoomScene template items
    let rsItems = sceneData.map(scene => <RoomScene 
        key={scene.productId} 
        specifier={scene.specifier} 
        thumbnailSize={thumbnailSize} 
        onSelect={handleRoomsceneSelect}
        isActive={false}
        />)

    return(
        <div className={styles.roomsceneListContainer}>
            <ol className={styles.roomsceneList}>
                {rsItems}
            </ol>
        </div>
    )
}

// #TODO
// Manage roomscenen active status, Usage of context API?

